module.exports = __webpack_public_path__ + "img/services.85495caa.svg";